import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button, Toolbar, ToggleFilter, Pager } from "rhombus-react";
import { useHistory } from "react-router";

import ReportsGrid from './ReportsGrid';
import { QA_REPORT_COLUMNS } from "widgets/grid/columns/QAReportColumns";
import { QA_ROW_COUNT_OPTIONS } from "utils/constants";
import { Report } from "reducers/QAReports";
import { useCollectionFiltering } from "utils/DataGrid";

import "./ReportsModal.css";

export default function ReportsModal() {
	const history = useHistory()
		, dispatch = useDispatch()
		, qaReport = useSelector(state => state.qaReports)
		, [selectedView, setSelectedView] = useState("week")
		, viewOptions = {
			week: {
				name:"7 Days",
				title:"7 Days",
				value:"week",
			},
			month: {
				name:"30 Days",
				title:"30 Days",
				value:"month",
			},
		};

	const {
		filterInfo: { page, rpp, sort },
	} = useCollectionFiltering(
		qaReport,
		Report.setAdvancedFilter,
		() => {
			dispatch(Report.clearQAReport()).then(() => {
				dispatch(Report.loadQAReport(selectedView));
			});
		}
	);

	useEffect(() => {
		dispatch(Report.loadQAReport());
	}, []);

	function updateGroupView(view, enabled) {
		setSelectedView(view);
		// Set page 1 before loading report
		dispatch(Report.setPage(1));
		dispatch(Report.loadQAReport(view));
	}

	function Content() {
		const pagerProps = {
			showItemCount: true,
			initialPage: page,
			forcePage: page,
			pageSize: rpp,
			pageCount: qaReport.totalPages,
			maxItems: qaReport.totalItems,
			showItemWord: "",
			rowCountItems: QA_ROW_COUNT_OPTIONS,

			onPageChange: newPage => dispatch(Report.setPage(newPage)),
			onRowCountChange: newRPP => dispatch(Report.setRPP(newRPP)),
		};

		return (
			<div className="qa-reports-modal-content">
				<Toolbar className="qa-reports-toolbar">
					<ToggleFilter
						key="group-filter"
						values={Object.values(viewOptions)}
						selectedView={selectedView}
						onViewChange={updateGroupView}
					/>
				</Toolbar>
				<div className="grid">
					<ReportsGrid
						items={qaReport.items}
						columns={QA_REPORT_COLUMNS}
						isLoading={!qaReport.isLoaded}
						sort={sort}
					/>
					<Pager key="pager" {...pagerProps} />
				</div>
			</div>
		);
	}

	function closeModal() {
		history.replace("/qa-panel/");
	}

	function Footer() {
		return (
			<Button
				theme="default"
				onClick={closeModal}
			>Close</Button>
		);
	}

	let modalProps = {
		type: "modal",
		allowFullScreen: false,
		bladeProps: {
			verticallyCenter: true,
		},
		onClose: closeModal,
		setAppTitle: false,
		title: "QA Panel Reports",
		xClose: true,
		className: "qa-reports-modal",
		renderContent: Content,
		renderFooter: Footer,
	};

	return <Modal {...modalProps} />;
}
